import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  xShare(e) {
    const url = e.currentTarget.dataset.url;
    const windowFeatures =
      "location=yes, resizable=yes, toolbar=no, menubar=no, scrollbars=no, status=no, width=666, height=456";
    window.open(url, "", windowFeatures);
  }

  facebookShare(e) {
    const url = e.currentTarget.dataset.url;
    const windowFeatures = "width=600, height=400";
    window.open(url, "", windowFeatures);
  }

  urlCopy(e) {
    const url = e.currentTarget.dataset.url;
    const triggerElement = e.currentTarget;
    this.originalContent = triggerElement.innerHTML;
    navigator.clipboard.writeText(url).then(
      () => {
        triggerElement.innerHTML = "コピーしました！";
        setTimeout(() => {
          triggerElement.innerHTML = this.originalContent;
        }, 2000);
      },
      () => {
        alert("クリップボードにコピー出来ませんでした。");
      },
    );
  }
}
